var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchMusicMp3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m138.003 145.88c-1.85-1.467-4.269-2.007-6.563-1.468l-66.602 15.61c-3.493.818-5.963 3.935-5.963 7.522v47.047c-2.766-1.092-5.775-1.699-8.924-1.699-13.441 0-24.377 10.936-24.377 24.377s10.936 24.376 24.377 24.376 24.377-10.936 24.377-24.376v-63.6l51.149-11.988v37.3c-2.766-1.092-5.775-1.699-8.924-1.699-13.441 0-24.377 10.936-24.377 24.377s10.936 24.376 24.377 24.376 24.377-10.936 24.377-24.376v-69.724c0-2.36-1.078-4.59-2.927-6.055zm-88.052 100.312c-4.921 0-8.924-4.003-8.924-8.924s4.004-8.925 8.924-8.925 8.924 4.004 8.924 8.925-4.003 8.924-8.924 8.924zm66.602-15.61c-4.921 0-8.924-4.003-8.924-8.924s4.004-8.925 8.924-8.925 8.924 4.004 8.924 8.925-4.004 8.924-8.924 8.924z",
    fill: "#9d66d5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchMusicMp3);
export default __webpack_public_path__ + "static/media/searchMusicMp3.95bd70b5bb95cfa941bc225312eb0d68.svg";
export { ForwardRef as ReactComponent };